var map = {
	"./CurrentDetails": 7397,
	"./CurrentDetails.vue": 7397,
	"./EventDetails": 5418,
	"./EventDetails.vue": 5418,
	"./GallerieDetails": 6025,
	"./GallerieDetails.vue": 6025,
	"./Gallerien": 3878,
	"./Gallerien.vue": 3878,
	"./Kontakt": 9444,
	"./Kontakt.vue": 9444,
	"./Oeffnungszeiten": 2721,
	"./Oeffnungszeiten.vue": 2721,
	"./Programm": 9089,
	"./Programm.vue": 9089
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3218;